import React from "react";
import MainLayout from "../../../hoc/main";
import {Grid, TableData} from "../../../components";
import {connect} from "react-redux";
import {deleteGuestData, getGuestDatas,} from "../../../redux/modules/Guest/action";

class Guest extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datas: [],
        };
    }

    componentDidMount() {
        this.props.getGuestDatas();
    }

    UNSAFE_componentWillReceiveProps(np) {
        this.setState({
            datas: np.guest.datas,
        });
    }

    render() {
        // console.log(this.state.datas);
        const guestColumn = [
            {
                name: "Guest",
                path: "name",
                show: true,
            },
            {
                name: "Location",
                path: "location",
                show: true,
            },
            {
                name: "Gender",
                path: "gender",
                show: true,
            },
        ];

        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <TableData
                        addData={true}
                        trashBin={true}
                        path={this.props.location.pathname}
                        title={"Guest Data"}
                        data={this.props.guest.datas}
                        columns={guestColumn}
                        action={["update", "delete"]}
                        trash={true}
                        deleteAction={(id) => this.props.deleteGuestData(id)}
                    />
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    guest: state.guest,
});

const mapDispatchToProps = {
    getGuestDatas,
    deleteGuestData,
};

export default MainLayout(connect(mapStateToProps, mapDispatchToProps)(Guest));
